import './logo.styles.scss'

const Logo = () => (
  <span className="logo">
    <span className="logo-1">Brit</span>
    <span className="logo-2">lex</span>
  </span>
)

export default Logo
